import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { Testimonial } from '.';
import { isClient } from '../../util/helpers';
import './Testimonials.scss';

const Testimonials = (props) => {
  const {
    testimonials,
    isActive,
    isAnimating,
    setHeightHandler,
  } = props;
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: (isClient && window.innerWidth > 800) ? false : true, // eslint-disable-line
    centerPadding: (isClient && window.innerWidth > 800) ? 0 : '20%',
    afterChange: index => setActiveIndex(index),
    responsive: [
      {
        breakpoint: 99999,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          centerPadding: 0,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleResize = () => {
    setHeightHandler(
      sliderRef && sliderRef.current && sliderRef.current.innerSlider && sliderRef.current.innerSlider.state && sliderRef.current.innerSlider.state.slideHeight ? (
        sliderRef.current.innerSlider.state.slideHeight
      ) : 0,
    );
  };
  useEffect(() => {
    sliderRef.current.slickGoTo(activeIndex);
    if (isClient) {
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  });
  const classes = `${isActive ? ' active' : ''}${isAnimating ? ' is-animating' : ''}`;
  return (
    <div
      className={`testimonials${classes}`}
    >
      <Slider ref={sliderRef} {...settings}>
        {testimonials.map((testimonial, index) => (
          <Testimonial
            key={index} // eslint-disable-line
            index={index}
            isActive={index === activeIndex}
            setActiveIndex={setActiveIndex}
            {...testimonial}
          />
        ))}
      </Slider>
    </div>
  );
};

export default Testimonials;
